// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { rectangleCheckLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-rectangle-check-lines': IconRectangleCheckLines;
    }
}

/**
 * The icon component for the 'rectangleCheckLines' icon
 */
export class IconRectangleCheckLines extends IconSvg {
    public constructor() {
        super(rectangleCheckLines16X16);
    }
}

registerIconSvg('icon-rectangle-check-lines', IconRectangleCheckLines);
export const iconRectangleCheckLinesTag = 'nimble-icon-rectangle-check-lines';
